"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackgroundEvent = void 0;
const Exports_js_1 = require("./Exports.js");
class BackgroundEvent extends Exports_js_1.PlatformEvent {
    constructor(error) {
        super("BackgroundEvent", Exports_js_1.EventType.Error);
        this.privError = error;
    }
    get error() {
        return this.privError;
    }
}
exports.BackgroundEvent = BackgroundEvent;

//# sourceMappingURL=BackgroundError.js.map
